<template>
  <div>
    <a-card :bordered="false">
      <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="账期">
              <a-month-picker
                v-decorator="['carrier_month']"
                placeholder="请选择年月"
                :disabled-date="disabledDate"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="运营商">
              <a-select
                allow-clear
                :value="filterCarrierType"
                placeholder="全部运营商"
                @change="changeFilterCarrier"
              >
                <a-select-option v-for="item in carrierTypeOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="运营商账户">
              <a-select
                show-search
                allow-clear
                option-filter-prop="children"
                :disabled="!filterCarrierType"
                :loading="loadingCarrierAccountOptions"
                :value="filterCarrierAccountId"
                :placeholder="filterCarrierType ? '全部账户' : '请先选择运营商'"
                @change="changeFilterCarrierAccount"
              >
                <a-select-option v-for="item in carrierAccountOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="运营商套餐">
              <a-select
                show-search
                allow-clear
                option-filter-prop="children"
                :disabled="!filterCarrierType"
                :loading="loadingCarrierProductOptions"
                :value="filterCarrierProductId"
                :placeholder="filterCarrierType ? '全部套餐' : '请先选择运营商'"
                @change="changeFilterCarrierProduct"
              >
                <a-select-option v-for="item in carrierProductOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="客户">
              <a-select
                show-search
                allow-clear
                :filter-option="false"
                :value="filterTopAgentId"
                placeholder="搜索一级客户"
                @search="searchFilterAgents"
                @change="changeFilterAgent"
              >
                <a-select-option v-for="item in filterAgentOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="客户套餐">
              <a-select
                show-search
                allow-clear
                option-filter-prop="children"
                :disabled="!filterTopAgentId"
                :loading="loadingProductOptions"
                :value="filterProductId"
                :placeholder="filterTopAgentId ? '全部套餐' : '请先选择客户'"
                @change="changeFilterProduct"
              >
                <a-select-option v-for="item in productOptions" :key="item.id" :value="item.product_id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="ICCID">
              <a-input v-decorator="['iccid']" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="来源">
              <a-select v-decorator="['source']" allow-clear>
                <a-select-option value="monthly_job">月度批跑</a-select-option>
                <a-select-option value="purchase">采购入账</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit">搜索</a-button>
                <a-button
                  v-if="isShowMenu('sim_card_month_costs/rerun')"
                  html-type="button"
                  @click="handleRecalculate"
                >重算</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        size="middle"
        :scroll="{ x: 'max-content' }"
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <div slot="iccid" slot-scope="iccid, record">
          <a @click="showCard(record.sim_card_id)">{{ iccid }}</a>
        </div>
        <span slot="action" slot-scope="text, record">
          <a @click="showDetail(record)">明细</a>
        </span>
      </a-table>
    </a-card>

    <a-modal
      title="成本分项明细"
      :visible="detailVisible"
      width="880px"
      centered
      :mask-closable="false"
      @cancel="detailVisible = false"
    >
      <a-row>
        <a-col :span="12">
          <a-descriptions :column="1" class="simiot-descriptions">
            <a-descriptions-item label="ICCID">
              <a @click="showCard(detail.sim_card_id)">{{ detail.iccid }}</a>
            </a-descriptions-item>
            <a-descriptions-item label="号码">{{ detail.phone_number }}</a-descriptions-item>
            <a-descriptions-item label="账期月">{{ detail.carrier_month }}</a-descriptions-item>
            <a-descriptions-item label="来源">{{ detail.source_display }}</a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="12">
          <a-descriptions :column="1" class="simiot-descriptions simiot-descriptions-max-6">
            <a-descriptions-item label="运营商">{{ detail.carrier_type_display }}</a-descriptions-item>
            <a-descriptions-item label="运营商账户">{{ detail.carrier_account_name }}</a-descriptions-item>
            <a-descriptions-item label="运营商套餐">{{ detail.carrier_product_name }}</a-descriptions-item>
            <a-descriptions-item label="客户">{{ detail.agent_name }}</a-descriptions-item>
            <a-descriptions-item label="客户套餐">{{ detail.product_name }}</a-descriptions-item>
            <a-descriptions-item label="合计">{{ detail.cost_amount }}</a-descriptions-item>
          </a-descriptions>
        </a-col>
      </a-row>
      <a-table
        size="middle"
        :columns="lineColumns"
        :data-source="detail.lines || []"
        :pagination="false"
        row-key="id"
        style="margin-top: 8px"
      />
      <template slot="footer">
        <a-button class="ant-btn-primary" @click="detailVisible = false">关闭</a-button>
      </template>
    </a-modal>

    <show-sim-card
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
    />
  </div>
</template>

<script>
import { findSimCardMonthCosts, findSimCardMonthCostDetail, rerunSimCardMonthCost } from '@/api/sim_card_month_cost'
import { findAgentOptions } from '@/api/agent'
import { findAgentsProductsOptions } from '@/api/agents_product'
import { findCarrierAccountProductOptions, findCarrierProductOptionsByCarrierType } from '@/api/carrier_product'
import { findCarrierAccountOptions, findCarrierTypeOptions } from '@/api/common_options'
import { hasPermission } from '@/utils/permission'
import { formatYearMonth } from '@/utils/time'

export default {
  name: 'SimCardMonthCosts',
  components: {
    ShowSimCard: () => import('@/views/sim_cards/Show')
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      tableData: [],
      query: {},
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      columns: [
        { title: '账期月', dataIndex: 'carrier_month' },
        { title: 'ICCID', dataIndex: 'iccid', scopedSlots: { customRender: 'iccid' }},
        { title: '号码', dataIndex: 'phone_number' },
        { title: '运营商', dataIndex: 'carrier_type_display' },
        { title: '运营商账户', dataIndex: 'carrier_account_name' },
        { title: '运营商套餐', dataIndex: 'carrier_product_name' },
        { title: '客户', dataIndex: 'agent_name' },
        { title: '客户套餐', dataIndex: 'product_name' },
        { title: '来源', dataIndex: 'source_display' },
        { title: '成本合计', dataIndex: 'cost_amount' },
        { title: '操作', scopedSlots: { customRender: 'action' }}
      ],
      lineColumns: [
        { title: '分项', dataIndex: 'formula_display' },
        { title: '计量', dataIndex: 'meter' },
        { title: '用量', dataIndex: 'quantity' },
        { title: '单价', dataIndex: 'unit_price' },
        { title: '金额', dataIndex: 'cost_amount' }
      ],
      detailVisible: false,
      detail: {},
      isShowInfoModal: false,
      showingId: 0,
      carrierTypeOptions: findCarrierTypeOptions(),
      filterCarrierType: undefined,
      filterCarrierName: '',
      filterCarrierAccountId: undefined,
      filterCarrierAccountName: '',
      carrierAccountOptions: [],
      loadingCarrierAccountOptions: false,
      filterCarrierProductId: undefined,
      filterCarrierProductName: '',
      carrierProductOptions: [],
      loadingCarrierProductOptions: false,
      filterTopAgentId: undefined,
      filterAgentName: '',
      filterAgentOptions: [],
      filterProductId: undefined,
      filterProductName: '',
      productOptions: [],
      loadingProductOptions: false,
      agentSearchKeyword: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.query, {
        page: this.pagination.current,
        per_page: this.pagination.pageSize
      })
      findSimCardMonthCosts(params).then((res) => {
        this.tableData = res.data || []
        if (res.pagination) {
          this.pagination.total = res.pagination.total_count || res.pagination.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    currentFilters() {
      const values = this.form.getFieldsValue()
      const query = {
        carrier_month: formatYearMonth(values.carrier_month),
        iccid: values.iccid,
        source: values.source
      }
      if (this.filterCarrierType) {
        query.carrier_type = this.filterCarrierType
      }
      if (this.filterCarrierAccountId) {
        query.carrier_account_id = this.filterCarrierAccountId
      }
      if (this.filterCarrierProductId) {
        query.carrier_product_id = this.filterCarrierProductId
      }
      if (this.filterTopAgentId) {
        query.top_agent_id = this.filterTopAgentId
      }
      if (this.filterProductId) {
        query.product_id = this.filterProductId
      }
      return query
    },
    disabledDate(current) {
      return current && current.clone().endOf('month') >= this.$moment().endOf('month')
    },
    handleSearch(e) {
      e.preventDefault()
      this.query = this.currentFilters()
      this.pagination.current = 1
      this.fetchData()
    },
    changeFilterCarrier(value) {
      this.filterCarrierAccountId = undefined
      this.filterCarrierAccountName = ''
      this.carrierAccountOptions = []
      this.filterCarrierProductId = undefined
      this.filterCarrierProductName = ''
      this.carrierProductOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterCarrierType = undefined
        this.filterCarrierName = ''
        return
      }
      this.filterCarrierType = value
      const found = this.carrierTypeOptions.find((item) => item.value === value)
      this.filterCarrierName = found ? found.label : ''
      this.fetchCarrierAccountOptions(value)
      this.fetchCarrierProductOptions(value)
    },
    changeFilterCarrierAccount(value) {
      this.filterCarrierProductId = undefined
      this.filterCarrierProductName = ''
      this.carrierProductOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterCarrierAccountId = undefined
        this.filterCarrierAccountName = ''
        if (this.filterCarrierType) {
          this.fetchCarrierProductOptions(this.filterCarrierType)
        }
        return
      }
      this.filterCarrierAccountId = value
      const found = this.carrierAccountOptions.find((item) => item.id === value)
      this.filterCarrierAccountName = found ? found.name : ''
      this.fetchAccountProductOptions(value)
    },
    changeFilterCarrierProduct(value) {
      if (value === undefined || value === null || value === '') {
        this.filterCarrierProductId = undefined
        this.filterCarrierProductName = ''
        return
      }
      this.filterCarrierProductId = value
      const found = this.carrierProductOptions.find((item) => item.id === value)
      this.filterCarrierProductName = found ? found.name : ''
    },
    fetchCarrierAccountOptions(carrierType) {
      this.loadingCarrierAccountOptions = true
      findCarrierAccountOptions(carrierType).then((res) => {
        if (res.code === 0 && this.filterCarrierType === carrierType) {
          this.carrierAccountOptions = res.data || []
        }
        this.loadingCarrierAccountOptions = false
      }).catch(() => {
        this.loadingCarrierAccountOptions = false
      })
    },
    fetchCarrierProductOptions(carrierType) {
      this.loadingCarrierProductOptions = true
      findCarrierProductOptionsByCarrierType(carrierType).then((res) => {
        if (res.code === 0 && this.filterCarrierType === carrierType && !this.filterCarrierAccountId) {
          this.carrierProductOptions = res.data || []
        }
        this.loadingCarrierProductOptions = false
      }).catch(() => {
        this.loadingCarrierProductOptions = false
      })
    },
    fetchAccountProductOptions(carrierAccountId) {
      this.loadingCarrierProductOptions = true
      findCarrierAccountProductOptions(carrierAccountId).then((res) => {
        if (res.code === 0 && this.filterCarrierAccountId === carrierAccountId) {
          this.carrierProductOptions = res.data || []
        }
        this.loadingCarrierProductOptions = false
      }).catch(() => {
        this.loadingCarrierProductOptions = false
      })
    },
    searchFilterAgents(name) {
      const keyword = this.$lodash.trim(name)
      this.agentSearchKeyword = keyword
      if (!keyword) {
        this.filterAgentOptions = []
        return
      }
      findAgentOptions({ name: keyword }).then((res) => {
        if (res.code === 0 && this.agentSearchKeyword === keyword) {
          this.filterAgentOptions = res.data || []
        }
      })
    },
    changeFilterAgent(value) {
      this.filterProductId = undefined
      this.filterProductName = ''
      this.productOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterTopAgentId = undefined
        this.filterAgentName = ''
        return
      }
      this.filterTopAgentId = value
      const found = this.filterAgentOptions.find((item) => item.id === value)
      this.filterAgentName = found ? found.name : ''
      this.fetchProductOptions(value)
    },
    changeFilterProduct(value) {
      if (value === undefined || value === null || value === '') {
        this.filterProductId = undefined
        this.filterProductName = ''
        return
      }
      this.filterProductId = value
      const found = this.productOptions.find((item) => item.product_id === value)
      this.filterProductName = found ? found.name : ''
    },
    fetchProductOptions(agentId) {
      this.loadingProductOptions = true
      findAgentsProductsOptions({ agent_id: agentId, include_ineffective: true }).then((res) => {
        if (res.code === 0 && this.filterTopAgentId === agentId) {
          this.productOptions = res.data || []
        }
        this.loadingProductOptions = false
      }).catch(() => {
        this.loadingProductOptions = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchData()
    },
    showCard(id) {
      if (!id) {
        return
      }
      this.showingId = id
      this.isShowInfoModal = true
    },
    showDetail(record) {
      findSimCardMonthCostDetail(record.id).then((res) => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    handleRecalculate() {
      const filters = this.currentFilters()
      if (!filters.carrier_month) {
        this.$message.warning('请选择账期')
        return
      }
      const monthLabel = this.form.getFieldValue('carrier_month').format('YYYY-MM')
      const parts = [monthLabel]
      if (this.filterCarrierType) {
        parts.push(this.filterCarrierName || this.filterCarrierType)
      }
      if (this.filterCarrierAccountId) {
        parts.push(`运营商账户「${this.filterCarrierAccountName || this.filterCarrierAccountId}」`)
      }
      if (this.filterCarrierProductId) {
        parts.push(`运营商套餐「${this.filterCarrierProductName || this.filterCarrierProductId}」`)
      }
      if (this.filterTopAgentId) {
        parts.push(`客户「${this.filterAgentName || this.filterTopAgentId}」`)
      }
      if (this.filterProductId) {
        parts.push(`套餐「${this.filterProductName || this.filterProductId}」`)
      }
      if (filters.iccid) {
        parts.push(`ICCID ${filters.iccid}`)
      }
      const that = this
      this.$confirm({
        title: `确认按 ${parts.join('、')} 重算月度成本？`,
        onOk() {
          const payload = { carrier_month: filters.carrier_month }
          if (filters.carrier_type) {
            payload.carrier_type = filters.carrier_type
          }
          if (filters.carrier_account_id) {
            payload.carrier_account_id = filters.carrier_account_id
          }
          if (filters.carrier_product_id) {
            payload.carrier_product_id = filters.carrier_product_id
          }
          if (filters.top_agent_id) {
            payload.top_agent_id = filters.top_agent_id
          }
          if (filters.product_id) {
            payload.product_id = filters.product_id
          }
          if (filters.iccid) {
            payload.iccid = filters.iccid
          }
          return rerunSimCardMonthCost(payload).then(() => {
            that.query = filters
            that.pagination.current = 1
            that.fetchData()
          })
        }
      })
    }
  }
}
</script>
